export const callerPhoneNumber = '20000';
export const callerPhoneNumberAnonymous = 'anonymous';
export const phoneNumberDefault = '20353';
export const sbcDisconnectCounterMax = 3;
